<template>
  <div class="panel-body">
    <v-flex xs12>
      <v-card v-model="myrule">

        <v-card-title primary-title>
            <div>
                <div class="headline">Rule</div>
                <div>{{ this.ruleTypes[this.rules.ruleTypeId] }} with {{ this.ruleActionTypes[this.rules.ruleActionTypeId] }} of {{ this.rules.amount}}</div>
            </div>
        </v-card-title>

        <div>
            <v-tabs slot="extension" v-model="model" color="blue" slider-color="yellow">
            <v-tab :key="ruleDetailTab">Details</v-tab>
            <v-tab :key="ruleHistoryTab">Execution History</v-tab>
            </v-tabs>

            <v-spacer></v-spacer>

            <v-tabs-items v-model="model">

                <v-tab-item :key="ruleDetailTab">
                 <v-layout>
                    <v-flex xs7>
                        <v-card-text class="pa-1 ml-2">Id: {{ this.rules.userSelectedRuleId }}</v-card-text>
                        <v-card-text class="pa-1 ml-2">Username: {{ this.rules.username }}</v-card-text>
                        <v-card-text class="pa-1 ml-2">Created Date: {{ formatDate(this.rules.createdDate) }}</v-card-text>
                        <v-card-text class="pa-1 ml-2">Updated Date: {{ formatDate(this.rules.updatedDate) }}</v-card-text>
                        <v-card-text class="pa-1 ml-2">Start Date: {{ formatDate(this.rules.startDate) }}</v-card-text>
                        <v-card-text class="pa-1 ml-2">End Date: {{ formatDate(this.rules.endDate) }}</v-card-text>
                        <v-card-text class="pa-1 ml-2">Jar ID: {{ this.rules.targetJarId }}</v-card-text>
                        <v-card-text class="pa-1 ml-2">Category: {{ this.rules.merchantWishlistCategoryName }}</v-card-text>
                        <v-card-text class="pa-1 ml-2">Subcategory: {{ this.rules.merchantWishlistSubcategoryName }}</v-card-text>
                        <v-card-text class="pa-1 ml-2">Merchant: {{ this.rules.merchantName }}</v-card-text>
                        <v-card-text class="pa-1 ml-2">Budgeting Days: {{ this.rules.budgetingDaysCount }}</v-card-text>
                        <v-card-text class="pa-1 ml-2">Budgeting Start Day: {{ this.rules.budgetingStartDayOfMonth }}</v-card-text>
                        <v-card-text class="pa-1 ml-2">Calendar Day: {{ this.rules.calendarDay }}</v-card-text>
                        <v-card-text class="pa-1 ml-2">Day Of Week: {{ this.rules.dayOfWeek }}</v-card-text>
                        <v-card-text class="pa-1 ml-2">Fitness Goal Type: {{ this.rules.fitnessGoalTypeId }}</v-card-text>
                        <v-card-text class="pa-1 ml-2">Deposit Source: {{ this.rules.depositTransactionKey }}</v-card-text>
                        <v-card-text class="pa-1 ml-2">Max Skips: {{ this.rules.maxSkips }}</v-card-text>
                        <v-card-text class="pa-1 ml-2">Active: {{ this.rules.active }}</v-card-text>
                    </v-flex>
                  </v-layout>
                </v-tab-item>

                <v-tab-item :key="ruleHistoryTab">
                    <v-data-table
                    a
                    :headers="headers"
                    :items="rulesExecHistory"
                    item-key="ruleExecutionResultId"
                    class="elevation-1"
                    :rows-per-page="ruleExecRowsPerPage"
                    :items-per-page-options="rppItems"
                    >
                      <template v-slot:item.executeDate="{item}">
                        <span>{{ formatDate(item.executeDate) }}</span>
                      </template>
                      <template v-slot:item.amount="{item}">
                        <span>${{ formatAmount(item.amount) }}</span>
                      </template>
                    </v-data-table>

                </v-tab-item>

            </v-tabs-items>

        </div>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </div>
</template>

<script>
// import jarHistory from '@/components/JarHistory.vue'
// import jarDetail from '@/components/JarDetails.vue'
// import jarAddFunds from '@/components/JarAddFundsDialog.vue'
import moment from 'moment'

let rh = require('@/components/APIs/RequestHandler')

export default {
  props: {
    rules: {
      type: Object,
      required: true
    },
    user: {
      type: Object,
      required: true
    },
    activeTab: {
      required: false,
      default: 0
    }
  },
  data: () => ({
    userId: '',
    myrule: false,
    search: '',
    model: null,
    rppItems: [
      10,
      25,
      50,
      { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 }
    ],
    rowsPerPage: 10,
    rulesExecHistory: [],
    ruleExecRowsPerPage: 10,
    errors: [],
    ruleActionTypes: {
      1: 'Round up',
      2: 'Percentage',
      3: 'Set amount'
    },
    ruleTypes: {
      1: 'Merchant',
      2: 'Deposit',
      3: 'Budget',
      4: 'Monthly',
      5: 'System - Deposit source',
      6: 'System - Merchant frequency',
      7: 'System - Merchant spend',
      8: 'System - Categorization',
      9: 'Manual',
      10: 'Daily',
      11: 'Weekly',
      12: 'Fitness',
      13: 'Sports',
      14: 'Challenge',
      15: 'Unused',
      16: 'Biweekly'
    },
    ruleDetailTab: null,
    ruleHistoryTab: null,
    // jarHistoryTab: null,
    // jarDetailTab: null,
    // jarAddFundsTab: null,
    headers: [
      { text: 'Id', align: 'left', value: 'ruleExecutionResultId' },
      { text: 'Rule Id', value: 'userSelectedRuleId' },
      { text: 'Jar Id', value: 'targetJarId' },
      { text: 'Status', value: 'status' },
      { text: 'Execute Date', value: 'executeDate' },
      { text: 'Amount', value: 'amount' }
    ]
  }),
  //   computed: {
  //     formTitle () {
  //       if (
  //         this.user === undefined ||
  //         this.user == null ||
  //         this.jar === undefined ||
  //         this.jar == null
  //       ) {
  //         return 'Jar'
  //       } else {
  //         return (
  //           this.jar.name +
  //           ' Jar for ' +
  //           this.user.firstName +
  //           ' ' +
  //           this.user.lastName
  //         )
  //       }
  //     }
  //   },
  watch: {
    activeTab: {
      immediate: true,
      deep: true,
      handler (newValue, oldValue) {
        this.model = newValue
      }
    }
  },
  created () {
    this.loadRuleExecHistory()
  },
  mounted () {
    this.model = this.activeTab
  },
  //   components: {
  //     jarHistory,
  //     jarDetail,
  //     jarAddFunds
  //   },
  methods: {
    close () {
      if (this.$refs.jarHistoryRef) {
        this.$refs.jarHistoryRef.history = []
      }
      if (this.$refs.jarAddFundsRef) this.$refs.jarAddFundsRef.initialize()
      this.model = 0
      this.$emit('close-rule')
    },
    // hasWishlist () {
    //   return !(
    //     this.jar === undefined ||
    //     this.jar == null ||
    //     this.jar.wishlist == null
    //   )
    // },
    loadJarDetails () {},
    async loadRuleExecHistory () {
      if (
        this.user === undefined ||
        this.user.userId == null ||
        this.user.userId === ''
      ) {
        // console.log('User ID not set, unable to load rules')
        this.rulesExecHistory = []
        return
      }
      this.loadingRules = true
      var endpoint = `${process.env.VUE_APP_QUBER_SERVICE_RULEEXECUTION}/execution?username=${this.user.quberUserName}&userSelectedRuleId=${this.rules.userSelectedRuleId}`

      // console.log('Loading rules from endpoint: ', endpoint)

      var getResponse = await rh.default.get(endpoint, true).catch(e => {
        this.errors.push(e)
      })

      if (getResponse === undefined) {
        this.rulesExecHistory = []
        // console.log('Couldnt get username')
      } else {
        this.rulesExecHistory = getResponse.data
        // console.log(
        // 'GOT QUBER USERNAME: %s',
        // console.log(JSON.parse(JSON.stringify(getResponse)))
        // )
      }

      this.loadingRules = false
    },
    formatDate (aDate) {
      if (aDate == null) {
        return null
      }
      return moment(String(aDate)).format('MM/DD/YYYY hh:mm:ss')
    },
    formatAmount (amount) {
      if (amount == null) {
        return null
      }
      return (amount / 100).toFixed(2)
    }
  }
}
</script>
<style>
table.v-table tbody td:first-child,
table.v-table tbody td:not(:first-child),
table.v-table tbody th:first-child,
table.v-table tbody th:not(:first-child),
table.v-table thead td:first-child,
table.v-table thead td:not(:first-child),
table.v-table thead th:first-child,
table.v-table thead th:not(:first-child) {
  padding: 0 10px;
}
</style>
